import React from "react";
import { Button, Modal } from "react-bootstrap";

const DeleteModel = ({ showModal, setShowModal, onYes }) => {
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div style={{ fontSize: 15 }}>
            Are you sure you want to delete this data? It cannot be recovered.
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-end align-item-center">
          <Button variant="primary" type="submit" onClick={onYes}>
            Yes
          </Button>
          <Button
            variant="white"
            className="border-1 border-dark ms-2"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModel;
